<template>
  <section class="container-fluid">
    <CRow class="justify-content-center">
      <CCol md="8">
        <CCard>
          <CCardHeader>
            <strong>Añadir curso</strong>
          </CCardHeader>
          <CCardBody>
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <form @submit.prevent="add">
                <section class="row">
                  <!-- Nombre -->
                  <div class="col-12">
                    <div class="form-group required">
                      <ValidationProvider
                        name="name"
                        rules="required|uniqueName|max:60"
                        :debounce="500"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="name">Nombre</label>
                        <input
                          type="text"
                          v-model="course.name"
                          class="form-control form-control-sm"
                          id="name"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Descripción -->
                  <div class="col-12">
                    <div class="form-group">
                      <ValidationProvider
                        name="content"
                        rules="max:600"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="content"
                          >Descripción
                        </label>
                        <b-form-textarea
                          id="content"
                          v-model="course.content"
                          class="form-control form-control-sm"
                          rows="2"
                          max-rows="3"
                        ></b-form-textarea>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>
                <router-link to="/cursos" custom v-slot="{ href, navigate }">
                  <a
                    :href="href"
                    class="card-header-action btn btn-sm btn-danger"
                    @click="navigate"
                  >
                    <CIcon size="sm" name="cil-x-circle" /> Cancelar
                  </a>
                </router-link>
                <button
                  type="submit"
                  class="btn btn-success btn-sm float-right"
                  variant="success"
                  :disabled="invalid || addLoader"
                >
                  <span v-if="!addLoader">
                    <CIcon size="sm" name="cil-save" /> Guardar
                  </span>
                  <span v-if="addLoader">
                    Cargando
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </form>
            </ValidationObserver>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import { BFormInvalidFeedback, BFormTextarea } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
//services
import Cursos from "@/plugins/services/courses";

export default {
  name: "CourseAdd",
  components: { BFormInvalidFeedback, BFormTextarea },
  data() {
    return {
      course: {
        enabled: true,
      },
      addLoader: false,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("uniqueName", {
      validate: this.isUniqueName,
      message: "El nombre ya existe.",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });
  },
  methods: {
    add() {
      this.addLoader = true;
      this.course.created_by = this.userAuth.username;
      Cursos.add(this.course)
        .then((res) => {
          this.addLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.$router.push("/cursos");
          } else {
            Utils.setFlash("danger", res.data.message);
            this.$router.push("/cursos");
          }
        })
        .catch((err) => {
          this.addLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Curso no encontrado.");
            this.$router.push("/cursos");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al crear(500).");
            this.$router.push("/cursos");
          }
        });
    },
    async isUniqueName() {
      return Cursos.existName(this.course.name)
        .then((res) => {
          if (res.data.data) {
            return false;
          } else {
            return true;
          }
        })
        .catch((err) => {
          return true;
        });
    },
  },
};
</script>
